import React, { useEffect, useState } from "react";

import * as style from "./RoleAssignmentRequests.module.scss";
import { useNavigate } from "react-router-dom";
import ActiveRoleAssignmentRequests from "./ActiveRoleAssignmentRequests";
import ArchivedRoleAssignmentRequests from "./ArchivedRoleAssignmentRequests";
import { Tabs, Tab } from "@mui/material";
import {
  updateCurrentStep,
  updateFeatureStatus,
} from "../../store/slices/featureGroupWithFeatureSlice";
import { AppDispatch } from "../../store/store";
import { useDispatch } from "react-redux";

import Button from "../../Components/Common/CprimeButton";
const RoleAssignmentRequests = () => {
  const scssClass = style as any;
  const navigate = useNavigate();

  const [selectedTab, setSelectedTab] = useState(0);
  const dispatch = useDispatch<AppDispatch>();

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };
  useEffect(() => {
    dispatch(updateCurrentStep(2));
  }, [dispatch]);

  return (
    <div className={scssClass.mainContainer}>
      <div className={scssClass.container}>
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            flexDirection: "column",
          }}
        >
          <div className={scssClass.header}>
            <p className={scssClass.title}>Role Assignment Request</p>
            <Button
              variant="secondary"
              onClick={() => {
                dispatch(updateCurrentStep(2));
                dispatch(updateFeatureStatus("idle"));
                navigate("/request-access");
              }}
              sx={{
                height: "40px",
                width: "140px",
              }}
            >
              Request Access
            </Button>
          </div>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            variant="standard"
            aria-label="role assignment requests tabs"
            sx={{
              "& .MuiButtonBase-root": {
                color: "black !important",
                backgroundColor: "white",
              },
              "& .MuiTabs-indicator": {
                color: "black !important",
                backgroundColor: "black !important",
              },
              "& .MuiTabs-root": {
                marginBottom: "0px !important",
              },
            }}
          >
            <Tab
              label="Active"
              sx={{
                padding: "1rem 2rem",
                textTransform: "none",
                fontWeight: selectedTab === 0 ? "bold" : "",
              }}
            />
            <Tab
              label="Archived"
              sx={{
                padding: "1rem 2rem",
                textTransform: "none",
                fontWeight: selectedTab === 1 ? "bold" : "",
              }}
            />
          </Tabs>
        </div>
      </div>

      <div className={scssClass.tableContainer}>
        {selectedTab === 0 && <ActiveRoleAssignmentRequests />}
        {selectedTab === 1 && <ArchivedRoleAssignmentRequests />}
      </div>
    </div>
  );
};

export default RoleAssignmentRequests;
